{
  "catalog": {
    "views": [
      "workflow-topbar-1",
      "business-alerts-3",
      "side-panel-card-list-5",
      "aside-6",
      "div-7",
      "catalog-page-header-8",
      "data-filter-panel-9",
      "data-table-10",
      "div-12",
      "div-15",
      "div-16",
      "div-17"
    ]
  },
  "access": {
    "views": [
      "workflow-topbar-1",
      "business-alerts-3",
      "side-panel-card-list-5",
      "button-6",
      "h1-7",
      "button-8",
      "button-9",
      "nav-12",
      "data-filter-panel-13",
      "data-table-14",
      "toggle-permission-list-15",
      "permission-matrix-16",
      "attribute-access-control-17",
      "div-20",
      "inherit-roles-popup-23",
      "div-24",
      "div-25",
      "div-27",
      "div-28"
    ]
  },
  "entities": {
    "views": [
      "workflow-topbar-1",
      "side-panel-card-list-3",
      "div-4",
      "div-5",
      "entity-detail-accordion-6",
      "div-8"
    ]
  },
  "pipeline": {
    "views": [
      "workflow-topbar-1",
      "business-alerts-3",
      "div-4",
      "div-5",
      "div-6",
      "div-7",
      "div-8",
      "workflow-configuration-panel-10",
      "div-12",
      "div-13",
      "p-18"
    ]
  },
  "pipelines": {
    "views": [
      "workflow-topbar-1",
      "business-alerts-3",
      "workflow-pipeline-list-4",
      "p-7"
    ]
  },
  "audit": {
    "views": [
      "workflow-topbar-1",
      "business-alerts-3",
      "side-panel-card-list-4",
      "header-6",
      "data-filter-panel-7",
      "data-table-8",
      "div-14"
    ]
  },
  "pricing": {
    "views": [
      "workflow-topbar-1",
      "business-alerts-3",
      "side-panel-card-list-5",
      "price-recommendation-7",
      "div-11",
      "div-12"
    ]
  }
}
